import type { Capabilities } from '@kioskforge/shared';

/**
 * The capability profile an admin surface assumes for a device class — the mirror
 * of what a real device claims on pairing, and the same list the deployment gate
 * is handed. Shared by the Layouts "RUNS ON" panel (A5b.3) and the preview
 * (A5b.11/A5b.12) so the two can never disagree.
 */
export function deviceProfile(deviceClass: 'tablet' | 'esp32'): Capabilities {
  return {
    device_class: deviceClass,
    lockdown: 'pwa',
    touch: true,
    screen_w: deviceClass === 'esp32' ? 800 : 1280,
    screen_h: deviceClass === 'esp32' ? 480 : 800,
    blocks: deviceClass === 'esp32'
      ? ['media', 'text', 'buttons', 'rating', 'live_tile']
      : ['media', 'text', 'buttons', 'form', 'consent', 'rating', 'live_tile', 'web_embed'],
    app_version: '0.1.0'
  };
}
